import type { CompanyState } from '../../../../types/company';

interface MarketingSectionProps {
  companyState: CompanyState;
  onNavigate?: () => void;
}

export function MarketingSection({ onNavigate }: MarketingSectionProps) {
  const campaigns = [
    { name: 'TV Ad Campaign', status: 'Active', color: 'green' },
    { name: 'Pre-launch Teaser', status: 'Pending', color: 'yellow' }
  ];

  return (
    <div className="border border-theme-border bg-theme-bg-content/50 rounded-lg relative overflow-hidden h-full">
      <button
        onClick={onNavigate}
        className={`absolute top-0 left-0 right-0 z-10 bg-theme-bg-content p-2 text-center font-bold text-sm text-theme-text-secondary border-b border-theme-border ${
          onNavigate ? 'hover:bg-theme-bg-tertiary hover:text-theme-info transition-colors cursor-pointer' : ''
        }`}
        disabled={!onNavigate}
      >
        Marketing
      </button>
      <div className="pt-10 p-3 h-full overflow-y-auto scroll-smooth scrollbar-hide" style={{ scrollbarWidth: 'none' }}>
        {campaigns.map((campaign, index) => (
          <div key={index} className="bg-theme-bg-content/80 rounded p-2 mb-2">
            <div className="flex justify-between items-center">
              <span className="flex items-center text-xs">
                <span className={`inline-block w-2 h-2 rounded-full mr-2 ${
                  campaign.color === 'green' ? 'bg-theme-success' : 'bg-theme-warning'
                }`}></span>
                {campaign.name}
              </span>
              <span className="text-xs">{campaign.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}